let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iRSLc")).then(() => parcelRequire('c3FF8'));